import { useEffect, useState } from "react";
import { useUserInfoMutation } from "../features/auth/api/authApi";
import { useDispatch } from "react-redux";
import { setUser } from "../features/auth/slices/authSlice";

const PUBLIC_PATHS = ['/login', '/reset-password'];

const RequireAuth = ({ children }) => {
    const location = window.location.pathname;
    const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking, true = authenticated, false = not authenticated
    const [userInfoApi] = useUserInfoMutation();
    const dispatch = useDispatch();

    useEffect(() => {
        const checkAuth = async () => {
            // If on public path, no need to check auth
            if (PUBLIC_PATHS.includes(location)) {
                setIsAuthenticated(false);
                return;
            }

            try {
                // Try to fetch user info - this will use the HTTP-only cookie
                const response = await userInfoApi().unwrap();
                if (response?.success && response?.data?.id) {
                    dispatch(setUser(response.data));
                    setIsAuthenticated(true);
                } else {
                    setIsAuthenticated(false);
                }
            } catch (error) {
                // If API call fails, user is not authenticated
                setIsAuthenticated(false);
            }
        };

        checkAuth();
    }, [location]);

    // Show loading state while checking authentication
    if (isAuthenticated === null) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <div>Loading...</div>
        </div>;
    }

    // Redirect logic
    if (!isAuthenticated && !PUBLIC_PATHS.includes(location)) {
        window.location.href = '/login';
        return null;
    }

    if (isAuthenticated && location === '/login') {
        window.location.href = '/';
        return null;
    }

    return children;
}

export default RequireAuth;
